// extracted by mini-css-extract-plugin
export var navItemsContainer = "hF_qD";
export var navListContainer = "hF_qC";
export var threeRows = "hF_qG";
export var title = "hF_h";
export var twoRows = "hF_qF";